import React, { useEffect, useRef, useState } from "react";
import { getEstimateName, updateEstimateName } from "../../IndexedDB";
import "./Index.css";
import Popup from "reactjs-popup";
import alertIcon from "../../assets/img/alert_icon.svg";
import EditIcon from "@mui/icons-material/Edit";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import DescriptionIcon from "@mui/icons-material/Description";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import Tooltip from "@mui/material/Tooltip";
import greeHseLogo from "../../assets/img/greenhse-logo.png";
import jsPDF from "jspdf";
import printJS from "print-js";
import backArraow from "../../assets/img/back_arrow.svg";

const Header = (props) => {
  const {
    headerText,
    showEstimateName,
    showEditIcon,
    mode,
    containerRef,
    selectedProductcomp,
    lightPlacementPositions,
    onBackToHome,
  } = props;

  const [estimateName, setEstimateName] = useState("");
  const [newEstimateName, setNewEstimateName] = useState("");
  const [isSaved, setIsSaved] = useState(false);
  const [openSavePopup, setOpenSavePopup] = useState(false); //for save confirmation popup

  const clickRef = useRef();
  const navigate = useNavigate();

  // Fetch estimate name from IndexedDB
  const fetchEstimateName = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const fileName = params.get("file");
      const fetchedFile = await getEstimateName(fileName);
      if (fetchedFile) {
        setEstimateName(fetchedFile);
        setNewEstimateName(fetchedFile);
      } else {
        console.error("File not found in the database:", fileName);
      }
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  const UpdateEstimateName = async () => {
    const params = new URLSearchParams(window.location.search);
    var fileName = params.get("file");
    fileName = decodeURIComponent(fileName);
    await updateEstimateName(fileName, newEstimateName);
    setEstimateName(newEstimateName);
  };

  useEffect(() => {
    fetchEstimateName();
  }, []);

  // SAVE FUNCTION
  const handleSaveImage = async () => {
    const canvasElement = containerRef?.current;
    if (!canvasElement) return;

    const canvas = await html2canvas(canvasElement, {
      backgroundColor: null,
      scale: 2,
    });
    const imageData = canvas.toDataURL("image/png");

    const lightData = {
      selectedProduct: Array.isArray(selectedProductcomp)
        ? selectedProductcomp
        : selectedProductcomp
        ? [selectedProductcomp]
        : [],
      lightPlacementPositions: Array.isArray(lightPlacementPositions)
        ? lightPlacementPositions
        : [],
    };

    const layoutData = { image: imageData, lights: lightData };
    localStorage.setItem("savedLightingLayout", JSON.stringify(layoutData));
    setIsSaved(true);
  };

  // PRINT FUNCTION
  const handlePrint = async () => {
    const container = document.querySelector(".canvas");
    if (!container) return;

    const hiddenElements = document.querySelectorAll(
      ".drag-handle, .stretch-handle, .delete-button, .rotate-handle"
    );
    hiddenElements.forEach((el) => (el.style.display = "none"));

    const lightDots = document.querySelectorAll(
      ".canvas div[style*='border: 2px solid orange']"
    );
    lightDots.forEach((el) => (el.style.display = "none"));

    try {
      const renderedCanvas = await html2canvas(container, {
        useCORS: true,
        scale: 1,
        backgroundColor: "#ffffff",
      });

      const dataURL = renderedCanvas.toDataURL("image/png");
      
      // Calculate dimensions to fit on one page
      // Standard A4 page: 210mm x 297mm (8.27" x 11.69") at 96 DPI
      // Accounting for margins and header, usable area is approximately:
      const maxWidth = 750; // pixels (about 7.8 inches)
      const maxHeight = 950; // pixels (about 9.9 inches)
      
      const canvasWidth = renderedCanvas.width;
      const canvasHeight = renderedCanvas.height;
      
      // Calculate scaling to fit within page dimensions
      const widthRatio = maxWidth / canvasWidth;
      const heightRatio = maxHeight / canvasHeight;
      const scale = Math.min(widthRatio, heightRatio, 1); // Don't scale up, only down
      
      const scaledWidth = canvasWidth * scale;
      const scaledHeight = canvasHeight * scale;

      const printHTML = `
      <style>
        @media print {
          @page {
            size: A4;
            margin: 10mm;
          }
          body {
            margin: 0;
            padding: 0;
          }
          .print-container {
            width: 100%;
            height: 100vh;
            display: flex;
            flex-direction: column;
            page-break-inside: avoid;
          }
          .print-header {
            width: 100%;
            background: #fff;
            padding: 10px 0;
            text-align: right;
            flex-shrink: 0;
          }
          .print-content {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
          }
          .print-image {
            max-width: ${scaledWidth}px;
            max-height: ${scaledHeight}px;
            width: auto;
            height: auto;
            object-fit: contain;
            display: block;
          }
        }
      </style>
      <div class="print-container">
        <div class="print-header">
          <img src="${greeHseLogo}" alt="GreenHse Logo" style="height:60px; width:auto; display:inline-block; margin-right:20px;" />
          <div style="font-size:12px; color:#000; margin-top:5px; margin-right:20px;">
            info@greenhse.com, 123 Street, City
          </div>
        </div>
        <div class="print-content">
          <img src="${dataURL}" class="print-image" />
        </div>
      </div>
    `;

      printJS({
        printable: printHTML,
        documentTitle: "GreenHse",
        type: "raw-html",
        targetStyles: ["*"],
      });
    } catch (err) {
      console.error("Print failed:", err);
    } finally {
      // Step 5: Restore elements after printing
      hiddenElements.forEach((el) => (el.style.display = ""));
      lightDots.forEach((el) => (el.style.display = ""));
    }
  };

  // DOWNLOAD PDF FUNCTION
  const handleDownloadPDF = async () => {
    // Select the canvas container
    const container = document.querySelector(".canvas");
    if (!container) return;

    const hiddenElements = document.querySelectorAll(
      ".drag-handle, .stretch-handle, .delete-button, .rotate-handle"
    );
    hiddenElements.forEach((el) => (el.style.display = "none"));

    const lightDots = document.querySelectorAll(
      ".canvas div[style*='border: 2px solid orange']"
    );
    lightDots.forEach((el) => (el.style.display = "none"));

    try {
      const wrapper = document.createElement("div");
      wrapper.style.width = "800px";
      wrapper.style.padding = "20px";
      wrapper.style.background = "#fff";
      wrapper.style.position = "absolute";
      wrapper.style.left = "-9999px";
      wrapper.style.top = "-9999px";

      // Header: Logo + Email
      const header = document.createElement("div");
      header.style.display = "flex";
      header.style.flexDirection = "column";
      header.style.alignItems = "flex-end";
      header.style.marginBottom = "20px";

      const logo = document.createElement("img");
      logo.src = greeHseLogo;
      logo.style.width = "120px";
      logo.style.height = "auto";
      logo.style.marginBottom = "5px";

      const email = document.createElement("div");
      email.innerText = "info@greenhse.com, 123 Street, City";
      email.style.fontSize = "15px";
      email.style.color = "#000";
      email.style.textAlign = "right";
      email.style.width = "100%";
      email.style.marginBottom = "20px";

      header.appendChild(logo);
      header.appendChild(email);
      wrapper.appendChild(header);

      const clonedContainer = container.cloneNode(true);
      clonedContainer.style.width = "100%";
      clonedContainer.style.height = "auto";
      wrapper.appendChild(clonedContainer);

      // Append wrapper temporarily
      document.body.appendChild(wrapper);

      const canvas = await html2canvas(wrapper, { scale: 2, useCORS: true });

      document.body.removeChild(wrapper);

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pageWidth - 20;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);
      pdf.save(`${estimateName || "Layout"}.pdf`);
    } catch (err) {
      console.error("PDF generation failed:", err);
    } finally {
      hiddenElements.forEach((el) => (el.style.display = ""));
      lightDots.forEach((el) => (el.style.display = ""));
    }
  };

  return (
    <div className="header">
      {onBackToHome && (
        <div style={{ position: "absolute", right: "20px", top: "38px" }}>
          <button 
            onClick={onBackToHome}
            style={{
              background: "transparent",
              border: "none",
              display: "flex",
              alignItems: "center",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer"
            }}
          >
            <img src={backArraow} alt="Back" style={{ marginRight: "10px", width: "16px", height: "16px" }} />
            Back
          </button>
        </div>
      )}
      <h5>{headerText}</h5>

      <div className="edit-header">
        {showEditIcon && (
          <Popup
            trigger={<EditIcon />}
            position="right center"
            className="delete-popup-content-content"
          >
            {(close) => (
              <div className="delete-popup-button-block rename-popup">
                <div className="input-custom-block">
                  <h5>Rename</h5>
                  <input
                    type="text"
                    value={newEstimateName}
                    onChange={(e) => setNewEstimateName(e.target.value)}
                  />
                </div>
                <div className="delete-btn-block edit-delete-btn-block">
                  <div className="delete-btn-block-inner">
                    <button onClick={close}>Cancel</button>
                    <button
                      className="delete-block"
                      onClick={() => {
                        clickRef.current.open();
                        close();
                      }}
                    >
                      Rename
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Popup>
        )}

        <Popup ref={clickRef} position="right center" className="delete-popup">
          {(close) => (
            <div className="delete-popup-button-block">
              <div className="alert-icon-info">
                <div className="alert-icon">
                  <img src={alertIcon} alt="Alert" />
                </div>
                <h5>Confirm!</h5>
              </div>
              <p>Are you sure you want to Rename this estimate?</p>
              <div className="delete-btn-block">
                <button onClick={close}>Cancel</button>
                <button
                  className="delete-block button"
                  onClick={() => {
                    UpdateEstimateName();
                    close();
                  }}
                >
                  Rename
                </button>
              </div>
            </div>
          )}
        </Popup>

        {/*Changes start*/}
        {/*Add SAVE CONFIRMATION POPUP */}
        <Popup
          open={openSavePopup}
          onClose={() => setOpenSavePopup(false)}
          position="right center"
          className="delete-popup"
        >
          {(close) => (
            <div className="delete-popup-button-block">
              <div className="alert-icon-info">
                <div className="alert-icon">
                  <img src={alertIcon} alt="Alert" />
                </div>
                <h5>Confirm Save</h5>
              </div>
              <p>Do you want to save the current image and lights?</p>
              <div className="delete-btn-block">
                <button onClick={close}>No</button>
                <button
                  className="delete-block button"
                  onClick={async () => {
                    await handleSaveImage();
                    close();
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>

        <div className="header-sub-info-text">
          {showEstimateName && <h6>{estimateName}</h6>}
        </div>
      </div>

      {mode === "editview" && (
        <div className="header-right-icons d-flex justify-content-end ms-3 me-5">
          {!isSaved && (
            <button
              onClick={() => setOpenSavePopup(true)} //  open popup instead of alert
              style={{
                backgroundColor: "#5cb226",
                color: "white",
                border: "none",
                fontSize: "17px",
              }}
            >
              Save
            </button>
          )}

          {isSaved && (
            <div style={{ display: "flex", gap: "10px" }}>
              <Tooltip title="Estimate" arrow>
                <DescriptionIcon
                  style={{ fontSize: 30, cursor: "pointer" }}
                  onClick={() => {
                    const params = new URLSearchParams(window.location.search);
                    const currentImageId = params.get("file");

                    if (!currentImageId) {
                      console.warn("No image ID found in URL");
                      return;
                    }

                    // Get saved layouts
                    const layouts = JSON.parse(
                      localStorage.getItem("layouts") || "{}"
                    );
                    const prevLayout = layouts[currentImageId] || {};

                    // Ensure selectedProductcomp is always an array
                    const currentProducts = Array.isArray(selectedProductcomp)
                      ? selectedProductcomp
                      : selectedProductcomp
                      ? [selectedProductcomp]
                      : [];

                    const currentPositions = Array.isArray(
                      lightPlacementPositions
                    )
                      ? lightPlacementPositions
                      : [];

                    // ✅ Keep duplicates intact (no filtering)
                    const productsToSave = currentProducts;

                    // 🧮 Calculate total estimate including duplicates
                    const calculateTotal = (products) => {
                      return products.reduce((total, product) => {
                        const price = parseFloat(product.price) || 0;
                        const qty = parseInt(product.quantity) || 0;
                        const gst = parseFloat(product.gst) || 0;
                        return total + price * qty * (1 + gst / 100);
                      }, 0);
                    };

                    // 💾 Save layout with duplicates
                    layouts[currentImageId] = {
                      ...prevLayout,
                      lights: {
                        selectedProduct: productsToSave,
                        lightPlacementPositions: currentPositions,
                      },
                      estimate: calculateTotal(productsToSave),
                      combos: prevLayout.combos || [],
                      image: prevLayout.image || "",
                    };

                    // Save to localStorage
                    localStorage.setItem("layouts", JSON.stringify(layouts));

                    // Navigate to estimate page
                    navigate("/estimate", {
                      state: {
                        ...layouts[currentImageId],
                        currentImageId: currentImageId, // Include file name for navigation back
                      },
                    });
                  }}
                />
              </Tooltip>

              <Tooltip title="Print" arrow>
                <PrintIcon
                  style={{ fontSize: 30, cursor: "pointer" }}
                  onClick={handlePrint}
                />
              </Tooltip>

              <Tooltip title="Save as PDF" arrow>
                <SaveIcon
                  style={{ fontSize: 30, cursor: "pointer" }}
                  onClick={handleDownloadPDF}
                />
              </Tooltip>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;
